import {shortDateFormatter} from "../../gridFormatters";

export const storageTaggingDefs = [
    {
        "headerName": "Array Name",
        valueGetter: params => {
            return params?.data?.arrayName ?? params?.data?.deviceName;
        },
        "hide": false,
        "editable": false,
        "minWidth": 100
    },
    {
        "field": "vendor",
        "headerName": "Vendor",
        "hide": false,
        // 'cellEditor': 'agTextCellEditor',
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "dataCenter", "headerName": "Data Center", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "model",
        "headerName": "Model",
        "hide": true,
        "editable": false,
        "minWidth": 100
        // 'cellEditor': 'agTextCellEditor'
    },
    {
        "field": "iopsCapacity", "headerName": "IOPS Capacity", "hide": false,
        "editable": true, "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },
    {
        "field": "mbsecCapacity", "headerName": "MB/Sec Capacity", "hide": false,
        "editable": true, "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },
    {
        "field": "latencyThreshold", "headerName": "Latency Threshold", "hide": false,
        "editable": true, "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },
    {
        "field": "capacityThreshold", "headerName": "Capacity Threshold", "hide": false,
        "editable": true, "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },
    {
        "field": "tier", "headerName": "Tier", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "category", "headerName": "Category", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "operationalCategory", "headerName": "Operational Category", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "company", "headerName": "Company Name", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "application", "headerName": "Application", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "pricePerGB", "headerName": "Price per GB", "hide": false,
        "editable": true, "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },
    {
        "field": "virtualized", "headerName": "Virtualized", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "purchaseDate", "headerName": "Purchase Date ", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "endOfMaintenanceDate", "headerName": "End of Maintenance Date", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "endOfLifeDate", "headerName": "End of Life Date", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "contractNumber", "headerName": "Contract Number", "hide": false,
        "editable": true,
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },
    {
        "field": "displayName", "headerName": "Display Name", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "classification", "headerName": "Classification", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "geography", "headerName": "Geography", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "arrayStatusId", "headerName": "Array Status Id", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "retiredDate", "headerName": "Retired Date", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "deviceTypeCode", "headerName": "Device Type Code", "hide": false,
        "editable": true,
        "cellEditor": "agTextCellEditor",
        "minWidth": 100
    },
    {
        "field": "maintenanceCost", "headerName": "Maintenance Cost", "hide": false,
        "editable": true, "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },

];

export const virtualClusterTaggingDefs = [
    {
        "field": "clusterName",
        "headerName": "Cluster Name",
        "hide": false,
        "editable": false,
        "minWidth": 100
    },
    {
        "field": "vCenterName",
        "headerName": "vCenter Name",
        "hide": false,
        "editable": false,
        "minWidth": 100
    },
    {
        "field": "company",
        "headerName": "Company",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "description",
        "headerName": "Description",
        "hide": false,
        "cellEditor": "agTextCellEditor",
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "dataCenter",
        "headerName": "Data Center",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "category",
        "headerName": "Category",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "function",
        "headerName": "Function",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "percentMemoryCalc",
        "headerName": "% Memory Calculation",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },
    {
        "field": "percentCPUCalc",
        "headerName": "% CPU Calculation",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },
    {
        "field": "percentDiskCalc",
        "headerName": "% Disk Calculation",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    },
    {
        "field": "vmBuildThreshold",
        "headerName": "VM Build Capacity Threshold",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
    },
    {
        "field": "vCPUpCPUThreshold",
        "headerName": "vCPU to pCPU Threshold",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
    },
    {
        "field": "pricePerCPU",
        "headerName": "$ per CPU",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
    },
    {
        "field": "pricePerGiBMemory",
        "headerName": "$ per GiB Memory",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
    },
    {
        "field": "percentMemoryThreshold",
        "headerName": "% Memory Threshold",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
    },
    {
        "field": "percentCPUThreshold",
        "headerName": "% CPU Threshold",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
    },
    {
        "field": "percentDiskThreshold",
        "headerName": "% Disk Threshold",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
    }
];

export const virtualEsxHostTaggingDefs = [
    {
        "field": "esxHostName",
        "headerName": "ESX Host Name",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "clusterName",
        "headerName": "Cluster Name",
        "hide": false,
        "editable": false,
        "minWidth": 100
    },
    {
        "field": "vCenterName",
        "headerName": "vCenter Name",
        "hide": false,
        "editable": false,
        "minWidth": 100
    },

    {
        "field": "endOfServiceLife",
        "headerName": "End of Service Life",
        "hide": false,
        "cellEditor": "agDateCellEditor",
        "editable": true,
        "cellRenderer": shortDateFormatter,
        "minWidth": 100
    },
    {
        "field": "endOfSupport",
        "headerName": "End of Support",
        "cellEditor": "agDateCellEditor",
        "cellRenderer": shortDateFormatter,
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "maintenanceCost",
        "headerName": "Maintenance Cost",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
        "minWidth": 100
    }
];

export const switchTaggingDefs = [
    {
        "field": "switchName",
        "headerName": "Switch Name",
        "hide": false,
        "editable": false,
        "minWidth": 100
    },
    {
        "field": "dataCenter",
        "headerName": "Data Center",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "function",
        "headerName": "Function",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "fabric",
        "headerName": "Fabric",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "pricePerPortActivation",
        "headerName": "$ per Port Activation",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "endOfServiceLife",
        "headerName": "End of Service Life",
        "hide": false,
        "cellEditor": "agDateCellEditor",
        "editable": true,
        "cellRenderer": shortDateFormatter,
        "minWidth": 100
    }
];

export const databaseInstanceTaggingDefs = [
    {
        "field": "instanceName",
        "headerName": "Instance Name",
        "hide": false,
        "editable": false,
        "minWidth": 100
    },
    {
        "field": "dataCenter",
        "headerName": "Data Center",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "category",
        "headerName": "Category",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "storageType",
        "headerName": "Storage Type",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    }
];

export const cloudResourceTaggingDefs = [
    {
        "field": "resourceName",
        "headerName": "Resource Name",
        "hide": false,
        "editable": false,
        "minWidth": 100
    },
    {
        "field": "subscription",
        "headerName": "Subscription",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "geography",
        "headerName": "Geography",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "category",
        "headerName": "Category",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        "minWidth": 100
    },
    {
        "field": "pricePerCPU",
        "headerName": "$ per CPU",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
    },
    {
        "field": "pricePerGiBMemory",
        "headerName": "$ per GiB Memory",
        "hide": false,
        "editable": true,
        "type": "numericColumn",
        "cellEditor": "agNumberCellEditor",
    },
];